<script setup>
import { ref, onMounted } from 'vue';
import { apexDashboard } from '@/data/dashboard/apexChart'
import { create_chart_label } from '@/helper';

const props = defineProps({
  assessment_histories: {
    type: Object,
    required: true
  }
})

onMounted(()=>{
  console.log(props.assessment_histories)
  chart.value = build_chart()
})

const chart = ref({})
function build_chart(){
  // chart setting
  let series = [{
    name: 'Score',
    data: []
  }]
  let options = apexDashboard.options
  // chart setting end
  let total_assessment = 0
  let total_label = 0
  let merge_progress = []
  props.assessment_histories.forEach(history => {
    total_label += history.progress.length
    let sorted = history.progress.sort((a,b) =>  parseInt(a.id) - parseInt(b.id))
    merge_progress.push(...sorted)
    total_assessment += JSON.parse(sorted.at(-1).attributes.score).length
  })

  options.yaxis.max = total_assessment + 1
  let labels = create_chart_label([], total_label)

  if (merge_progress.length !== 0){
    let sorted_assessment = props.assessment_histories.sort((a,b) =>  parseInt(a.assessment.data.id) - parseInt(b.assessment.data.id))
    let highest_mark = 0
    let scores = []
    sorted_assessment.forEach(history => {
      let temp_scores = history.progress.map(item=>{
        return JSON.parse(item.attributes.score).length + highest_mark
      })
      highest_mark += JSON.parse(history.progress.at(-1).attributes.score).length
      scores.push(...temp_scores)
    })

    series[0].data = scores.map((item, ind) => {
      return {
        x: labels[ind], 
        y: item
      }
    })
  }

  return {
    series,
    options
  }
}
</script>

<template>
  <div class="card no-shadow border p-0 my-2">
    <div class="card-body py-2 row">
      <apexchart height="200" 
        type="line"
        :options="chart.options" 
        :series="chart.series" 
      ></apexchart>
    </div>
  </div>
</template>